import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const preferenceService = {
  // Get all genders
  getAllGenders: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.GENDERS);
      return response.data|| response;
    } catch (error) {
      throw error;
    }
  },

  // Get all preferred stocks
  getAllPrefStocks: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.PREF_STOCKS);
      return response.data|| response;
    } catch (error) {
      throw error;
    }
  },

  // Get all app preferences
  getAllPreferences: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.PREFERENCES);
      return response.data|| response;
    } catch (error) {
      throw error;
    }
  },

  // Get all timeline content preferences
  getAllTimelineContent: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.TIMELINE_CONTENT);
      return response.data|| response;
    } catch (error) {
      throw error;
    }
  },
};